export default __webpack_public_path__ + "static/media/loading_icon.be10760c.svg";